import { useEffect, useMemo, useRef } from 'react'
import { DOMImplementation, XMLSerializer } from 'xmldom'
import Jsbarcode from 'jsbarcode'

export const useBarcode = (barcode: string, useShortBarcode: boolean = false) => {
  return useMemo(() => {
    const xmlSerializer = new XMLSerializer()
    const document = new DOMImplementation().createDocument('http://www.w3.org/1999/xhtml', 'html', null)
    const svgNode = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    Jsbarcode(svgNode, barcode, {
      format: 'CODE39',
      xmlDocument: document,
      width: useShortBarcode ? 2.7 : 3.5,
      displayValue: false,
      height: useShortBarcode ? 150 : 118,
    })

    return xmlSerializer.serializeToString(svgNode)
  }, [barcode, useShortBarcode])
}

export const useBarcodeImage = (code: string, useShortBarcode: boolean = false) => {
  const svgBarcode = useBarcode(code, useShortBarcode)
  const blobUrlRef = useRef<string | null>(null)

  // Clean up previous blob URL when barcode changes or component unmounts
  useEffect(() => {
    return () => {
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current)
      }
    }
  }, [svgBarcode])

  return useMemo(() => {
    // Revoke previous URL before creating new one
    if (blobUrlRef.current) {
      URL.revokeObjectURL(blobUrlRef.current)
    }

    const blob = new Blob([svgBarcode], { type: 'image/svg+xml' })
    const img = document.createElement('img')
    const blobUrl = URL.createObjectURL(blob)
    blobUrlRef.current = blobUrl
    img.src = blobUrl
    return img
  }, [svgBarcode])
}
